import { ProjectActions } from '@octopus-do/octopus-project-core'
import { commitProjectRequest } from '@storeOld/actionCreators'

import type { AppState } from '@/types'
import { getId } from '@/utils/temporaryHelper'

export const deleteExternalLink =
  () =>
  (
    dispatch: (action: { type: string; payload?: any }) => void,
    getState: () => AppState
  ) => {
    const { canvas } = getState()

    if (!canvas.externalLink.selectedExternalLink) {
      return
    }

    dispatch(
      commitProjectRequest(
        ProjectActions.externalLinks.delete({
          ids: [canvas.externalLink.selectedExternalLink],
        })
      )
    )
  }

export const duplicateExternalLink =
  () =>
  () =>
  (
    dispatch: (action: { type: string; payload?: any }) => void,
    getState: () => AppState
  ) => {
    const { canvas } = getState()

    if (!canvas.externalLink.selectedExternalLink) {
      return
    }

    dispatch(
      commitProjectRequest(
        ProjectActions.externalLinks.clone({
          initiator: getId(),
          id: canvas.externalLink.selectedExternalLink,
        })
      )
    )
  }

export const removeExternalLinkImage = (id: string) =>
  commitProjectRequest(
    ProjectActions.externalLinks.updateData({
      id,
      data: {
        image: null,
      },
    })
  )
